import { render, staticRenderFns } from "./first-post.vue?vue&type=template&id=73e93578&scoped=true&"
import script from "./first-post.vue?vue&type=script&lang=js&"
export * from "./first-post.vue?vue&type=script&lang=js&"
import style0 from "./first-post.vue?vue&type=style&index=0&id=73e93578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e93578",
  null
  
)

export default component.exports